import { colors } from 'components/styles/variables';
import { resolve } from 'styled-jsx/css';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import tapEvent, { FooterAction } from 'lib/Tracking/Footer/TapEvent';
import useEvents from 'lib/hooks/useEvents';
import { SourcePages } from 'lib/EventSchema';
import Link, { LinkProps } from './Link';

/* istanbul ignore next */
const aCss = resolve`
.view-all {
  color: ${colors.G2};
  font-size: 14px;
}`;

interface ItemProps {
  href: string;
  onClick: () => void;
  children: JSX.Element | string;
  anchorProps?: LinkProps['anchorProps'];
}

function Item({ href, onClick, children, anchorProps }: ItemProps): JSX.Element {
  return (
    <li className="footer-see-all-list-item">
      <Link
        href={href}
        onClick={onClick}
        className={`${aCss.className} view-all`}
        anchorProps={anchorProps}
      >
        {children}
        {` `}
        <span className="right-caret">^</span>
      </Link>
      <style jsx>
        {`
          .right-caret {
            display: inline-block;
            transform: rotate(90deg);
          }

          .footer-see-all-list-item {
            list-style: none;
            text-transform: uppercase;
          }
        `}
      </style>
      {aCss.styles}
    </li>
  );
}

export default function SeeAll(): JSX.Element {
  const { t } = useTranslation();
  const logger = useEvents();
  const { asPath } = useRouter();

  function logFooterTapEvent(action: FooterAction): void {
    logger.log(tapEvent({ action, pathName: asPath as SourcePages }));
  }

  return (
    <ul className="see-all-links" role="navigation">
      <Item
        href="/used-cars-city-state"
        onClick={(): void => {
          logFooterTapEvent('see_all_cities');
        }}
        anchorProps={{
          'data-testid': 'footer-cities-link',
        }}
      >
        {t('footer.viewAllPopularCities')}
      </Item>
      <Item
        href="/used-models"
        onClick={(): void => {
          logFooterTapEvent('see_all_models');
        }}
        anchorProps={{
          'data-testid': 'footer-used-models-link',
        }}
      >
        {t('footer.viewAllPopularModels')}
      </Item>

      <Item
        href="/#body-styles"
        onClick={(): void => {
          logFooterTapEvent('see_all_categories');
        }}
        anchorProps={{
          'data-testid': 'footer-popular-categories-link',
        }}
      >
        {t('footer.viewAllPopularCategories')}
      </Item>
      <style jsx>
        {`
          .see-all-links {
            margin-left: 0;
            padding-left: 0;
          }
        `}
      </style>
    </ul>
  );
}
